"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'table.controls.export': '导出',
    'table.controls.columns': '列',
};
